import {useState} from 'react';

export function useAnnotatorState() {
  const [tooltip, setTooltip] = useState<{title: string; x: number; y: number}>({
    title: '',
    x: 0,
    y: 0,
  });

  const [selector, setSelector] = useState<{
    startX: number;
    startY: number;
    endX: number;
    endY: number;
    visible: boolean;
  }>({
    startX: 0,
    startY: 0,
    endX: 0,
    endY: 0,
    visible: false,
  });

  const [cursor, setCursor] = useState('default');
  const [isGrabbing, setIsGrabbing] = useState(false);
  const [isImageBusy, setIsImageBusy] = useState(false);
  const [isImageError, setIsImageError] = useState(false);
  const [isTransforming, setIsTransforming] = useState(false);

  const [instructionDialog, setInstructionDialog] = useState<{
    visible: boolean;
    x: number;
    y: number;
    htmlContent: React.ReactNode;
  }>({
    visible: false,
    x: 0,
    y: 0,
    htmlContent: null,
  });

  return {
    tooltip,
    setTooltip,

    selector,
    setSelector,

    cursor,
    setCursor,

    isGrabbing,
    setIsGrabbing,

    isImageBusy,
    setIsImageBusy,

    isImageError,
    setIsImageError,

    isTransforming,
    setIsTransforming,

    instructionDialog,
    setInstructionDialog,
  };
}
